import { render, staticRenderFns } from "./ProductionList.vue?vue&type=template&id=d95b62b8"
import script from "./ProductionList.vue?vue&type=script&lang=js"
export * from "./ProductionList.vue?vue&type=script&lang=js"
import style0 from "./ProductionList.vue?vue&type=style&index=0&id=d95b62b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports